
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/recycling-at-home",
      function () {
        return require("private-next-pages/articles/recycling-at-home.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/recycling-at-home"])
      });
    }
  